<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="個別サービス設定参照"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showServiceSettingModify"
                  >変更</v-btn
                >
                <v-btn
                  v-if="!serviceSetting.isPolicyInUse"
                  v-permission.config
                  color="primary"
                  @click="deleteServiceSetting"
                  class="ml-2"
                  >削除</v-btn
                >
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="名前"
                  :value="serviceSetting.serviceName"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="プロトコル"
                  :value="serviceSetting.protocol"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="Port"
                  :value="serviceSetting.portNumber"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="備考"
                  :value="$filter.emptyTo(serviceSetting.description, '-')"
                  class="text-pre-wrap"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="ポリシー使用有無"
                  :value="
                    $filter.enumTo(
                      serviceSetting.isPolicyInUse,
                      'isPolicyInUse'
                    )
                  "
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";
import ServiceSettingEdit from "@/modals/applianceObject/ServiceSettingEdit.vue";
import type {
  CustomServiceDelete,
  CustomServiceInfo,
} from "@/apis/CustomServiceApi";

export default defineComponent({
  name: "ServiceSettingReference",
  props: {
    serviceSetting: {
      type: Object as PropType<CustomServiceInfo>,
      required: true,
    },
    customServiceKeyId: {
      type: String as PropType<string>,
      required: true,
    },
    type4Id: {
      type: String as PropType<string>,
      required: false,
      default: null,
    },
  },
  methods: {
    /**
     * サービス設定の削除処理
     */
    async deleteServiceSetting(): Promise<void> {
      // 確認ダイアログの表示
      await this.$confirm("個別サービスを削除します。よろしいですか？");

      // リクエストデータの作成
      const reqData: CustomServiceDelete = {
        customServiceSeqList: [this.serviceSetting.customServiceSeq],
        customServiceKeyId: this.customServiceKeyId,
      };

      // サービス設定削除APIを呼び出す
      if (!this.type4Id) {
        await this.$api.customServiceApi.deleteType1CustomService(reqData);
      } else {
        await this.$api.customServiceApi.deleteType4CustomService(
          this.type4Id,
          reqData
        );
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * サービス設定更新のモーダルを表示する
     */
    async showServiceSettingModify(): Promise<void> {
      await this.$modal.show(ServiceSettingEdit, {
        serviceSetting: this.serviceSetting,
        customServiceKeyId: this.customServiceKeyId,
        type4Id: this.type4Id,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
